import React from 'react';
import slider1 from '../../../assets/images/dyslexia/table_slider1.png';
import slider2 from '../../../assets/images/dyslexia/slider_2.png';
import slider3 from '../../../assets/images/dyslexia/slider_3.png';
import slider4 from '../../../assets/images/dyslexia/slider_4.png';
import GradientButton from '../../../components/atoms/GradientButton';
import CrossFadeImageSlider from '../../../components/molecules/CrossFadeImageSlider';

function EarlyIntervention() {
  const images = [
    { src: slider1, alt: 'Dyslexia table practice in Wasilla, Alaska' },
    { src: slider2, alt: 'doing panint on paper therapy' },
    { src: slider3, alt: 'learning occupational therapy' },
    { src: slider4, alt: 'skeching a picture on mate' },
  ];

  return (
    <div className="w-full flex flex-col justify-between gap-4 sm:gap-10 max-w-[1200px] mx-auto px-4 md:px-10 py-10 relative z-10">
      <div className="flex flex-col md:flex-row justify-between w-full gap-4 sm:gap-10 xl:gap-32">
        <div className="flex-[45%] flex flex-col items-start gap-4 sm:gap-6 lg:gap-10 text-lg md:text-xl 2xl:text-2xl text-secondary">
          <h1 className="text-[32px] sm:text-[42px] md:text-[42px] text-[#7B54A2] font-bold leading-[40px] lg:leading-[50px]">
            Why Guidepost Pediatrics for Early Intervention?
          </h1>
          <p>
            Choosing the right partner for your child's developmental journey is
            crucial. Guidepost Pediatrics stands out as a premier early
            intervention center because we believe in a holistic,
            family-centered approach to care. Our collaborative team of
            dedicated pediatric specialists—including occupational, physical,
            and speech therapists—works together to create a comprehensive and
            personalized support system for your child.
          </p>
        </div>
        <div className="flex-[55%] flex justify-center overflow-hidden relative">
          <CrossFadeImageSlider
            width="w-[90vw] md:w-[550px]"
            height="h-[400px]"
            // rounded="rounded-lg"
            // height="h-[320px]"
            // width="w-[320px]"
            images={images}
          />
        </div>
      </div>
      <div className="w-full flex flex-col items-start gap-4 sm:gap-6 lg:gap-10 text-lg md:text-xl 2xl:text-2xl text-secondary">
        <p>
          We understand that dyslexia is not just a reading challenge; it can
          impact many areas of a child's life. Our multidisciplinary experts
          assess the whole child to develop a tailored intervention plan that
          builds on their strengths and addresses their unique needs. By
          integrating evidence-based strategies with a nurturing environment, we
          empower children to build the foundational skills necessary for
          learning and to thrive in all aspects of their lives. At Guidepost,
          your family becomes part of our community, ensuring you have the
          resources and support you need every step of the way.
        </p>

        <GradientButton
          navigateTo="/contact"
          text="Schedule an Evaluation"
          width="lg:w-[240px] w-full"
          rounded="rounded-none"
        />
      </div>
    </div>
  );
}

export default EarlyIntervention;
